module.exports = __webpack_public_path__ + "img/dizhi.a2dc06ba.svg";